import { useEffect, useState } from "react"
import Modal from "src/components/Common/Modal"
import Toast from "src/components/Common/Toast"
import CandidateApi from "src/services/apis/candidate"
import CandidateDetailsSection, { normalizeCandidateFormData } from "./CandidateDetailsSection"
import "./CandidateFormData.scss"

const CandidateFormData = ({ linkId, setCandidateFormDataLink }) => {
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState(null)

    useEffect(() => {
        if (linkId) {
            getCandidateFormData(linkId)
        }
    }, [linkId])

    const getCandidateFormData = async (linkId) => {
        try {
            setLoading(true)
            const response = await CandidateApi.getCandidateFormData(linkId)
            if (response.success) {
                setFormData(normalizeCandidateFormData(response.userData))
            }
        } catch (err) {
            console.error(err)
            Toast("error", err)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal
            modalVisible={linkId}
            cancelModal={() => {
                setFormData(null)
                setCandidateFormDataLink("")
            }}
            width="1008px"
            centered
            className="candidate-formdata-modal"
        >
            <CandidateDetailsSection formData={formData} loading={loading} />
        </Modal>
    )
}

export default CandidateFormData
